import { render, staticRenderFns } from "./contactdocument.vue?vue&type=template&id=3bb26e8e&scoped=true&"
import script from "./contactdocument.vue?vue&type=script&lang=js&"
export * from "./contactdocument.vue?vue&type=script&lang=js&"
import style0 from "./contactdocument.vue?vue&type=style&index=0&id=3bb26e8e&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb26e8e",
  null
  
)

export default component.exports